export default __webpack_public_path__ + "static/media/imageNotFound.51327a1f.jpg";